<template>
  <div>
    <v-data-table
      v-if="recipients"
      v-model="selectedRecipients"
      :headers="headers"
      :items="recipients"
      :items-per-page="10"
      :sort-by="['id']"
      sort-desc
      :show-select="!readonly"
      item-key="id"
      class="elevation-1"
      @toggle-select-all="toggleAll"
    >
      <template v-slot:item.reading_date="{ item }">
        {{ formatDate(item.reading_date) }}
      </template>

      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="persons.show"
          :route-params="{ id: item.person_id }"
          @show="$emit('show', item)"
        />
      </template>
    </v-data-table>
    <p>
      {{ $t('NOTIFICATIONS.TOTAL_NUMBER_OF_RECIPIENTS') }}:
      {{ numberSelectedRecipients }}
    </p>
  </div>
</template>

<script>
import { Notification } from '@/modules/notifications/Notification';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'Recipients',
  components: { ActionSlotComponent },

  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      required: true
    },
    recipientsSelectedBefore: {
      type: Array,
      default: null
    },
    notificationId: {
      type: Number,
      default: null
    }
  },

  data: () => ({
    recipients: [],
    selectedRecipients: [],
    numberSelectedRecipients: null
  }),

  computed: {
    headers() {
      let headersDynamic = [
        // {
        //   text: 'id',
        //   align: 'left',
        //   sortable: true,
        //   value: 'id'
        // },
        {
          text: this.$t('PERSONS.ITEM'),
          value: 'full_name'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER'),
          value: 'business_customer'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'building_complex'
        },
        {
          text: this.$t('BUILDINGS.ITEM'),
          value: 'building'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.MANAGEMENT_COMPANY'),
          value: 'management_company'
        }
      ];

      if (this.readonly) {
        headersDynamic.push({
          text: this.$t('NOTIFICATIONS.DATE_TIME_OF_READING'),
          value: 'reading_date'
        });
      }

      headersDynamic.push({ text: '', value: 'action', align: 'center' });

      return headersDynamic;
    }
  },

  watch: {
    selectedRecipients: {
      handler: 'setSelectedRecipients'
    },
    filters: {
      handler: 'getRecipients'
    }
  },

  created() {
    this.getRecipients();

    if (this.recipientsSelectedBefore) {
      this.selectedRecipients = this.recipientsSelectedBefore;
    }
  },

  methods: {
    toggleAll(v) {
      if (v.value) {
        this.selectedRecipients = this.recipients;
      } else {
        this.selectedRecipients = [];
      }
    },
    setSelectedRecipients() {
      this.$emit('change-selected-recipients', this.selectedRecipients);
      this.numberSelectedRecipients = this.selectedRecipients.length;
    },

    getRecipients() {
      let dataQuery = { filter: this.filters };

      if (this.readonly && this.notificationId) {
        dataQuery.notification_id = this.notificationId;
      }

      this.$store
        .dispatch('person/filterUsersForNotification', dataQuery)
        .then(response => {
          this.recipients = response.data;

          if (this.recipientsSelectedBefore) {
            this.selectedRecipients = this.recipientsSelectedBefore;
          } else {
            this.selectedRecipients = this.recipients;
          }
        })
        .catch(error => {
          this.error = error.response;
        });
    },

    formatDate(value) {
      return Notification.formatDate(value);
    }
  }
};
</script>
